import { FC } from 'react';

import { useHighlightPopupService } from './HighlighPopupService';

import styles from './EmulatedSideNavItems.module.scss';

export const PopupButtonContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { currentPopupRect } = useHighlightPopupService();
  return (
    <div
      className={styles['button-container']}
      style={{
        width: `${currentPopupRect?.width}px`,
        height: `${currentPopupRect?.height}px`,
        top: `${currentPopupRect?.top}px`,
        left: `${currentPopupRect?.left}px`,
      }}
    >
      {children}
    </div>
  );
};

export const PopupButton: FC<
  React.PropsWithChildren<{
    handleClick: () => void;
  }>
> = ({ children, handleClick }) => {
  return (
    <button
      onClick={(event) => {
        event.stopPropagation();
        handleClick();
      }}
      className={styles['button-content']}
    >
      {children}
    </button>
  );
};

export const PopupButtonIcon: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <span className={styles['button-icon']}>{children}</span>;
};

export const PopupButtonText: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <span className={styles['button-text']}>{children}</span>;
};
